var map = {
	"./black/fenzu.png": "Ussl",
	"./blue/fenzu.png": "tmqX",
	"./white/fenzu.png": "w7YA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BQF0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/fenzu\.png$
// module id = BQF0
// module chunks = 24